export default __webpack_public_path__ + "static/media/error.c894ea6d.svg";